import firebase from "firebase/app";
import "firebase/auth";

// firebase init goes here
const config = {
  apiKey: process.env.VUE_APP_FB_API_KEY,
  authDomain: process.env.VUE_APP_FB_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FB_PROJECT_ID,
};

firebase.initializeApp(config);

const auth = firebase.auth();

export { auth };
